import styles from "@website/widget/common/components/purchase-menu/components/purchase-card/purchase-card.module.scss";
import { PurchaseCardPropertiesType } from "@website/widget/common/components/purchase-menu/components/purchase-card/purchase-card.types";
import { FC, memo } from "react";

const PurchaseCard: FC<PurchaseCardPropertiesType> = (properties) => {
  const { list } = properties;
  return (
    <div className={styles["container"]}>
      {list
        ? list.map((item) =>
            item.type === "link" ? (
              <div
                className={styles["item"]}
                key={item.title}
                onClick={() => {
                  // onChangeRoute(item.url || "");
                }}
              >
                <span className={styles["item-icon"]}>{item.icon}</span>
                <div className={styles["item-title"]}>{item.title}</div>
              </div>
            ) : item.type === "button" ? (
              <div
                className={styles["item"]}
                key={item.title}
                onClick={item.onClick}
                role="button"
              >
                <span className={styles["item-icon"]}>{item.icon}</span>
                <div className={styles["item-title"]}>{item.title}</div>
              </div>
            ) : null
          )
        : null}
    </div>
  );
};

const PurchaseCardMemoized = memo(PurchaseCard);
export { PurchaseCardMemoized as PurchaseCard };
